const Check = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Icon'>
        <path
          id='check'
          d='M9.59509 18L4 12.3119L5.39877 10.8898L9.59509 15.1559L18.6012 6L20 7.42204L9.59509 18Z'
          fill='#00AEB3'
        />
      </g>
    </svg>
  );
};

export default Check;
